<div [ngClass]="{'banner-RE': category === 'RE', 'banner-MA': category === 'MA', 'banner-ALL': category === 'ALL'}">
  <div class="title-banner">
    {{ titleBeforeTotalSearch }}<span class="total-search">{{ totalSearch }}</span>{{ titleAfterTotalSearch }}
  </div>
  <div class="body-banner">{{ bannerBody }}</div>
</div>
